import { Component } from '@angular/core';
import { IonicPage, NavController, NavParams } from 'ionic-angular';
import { ArticlePage } from "../article/article";

@IonicPage()
@Component({
  selector: 'page-unit',
  templateUrl: 'unit.html',
})
export class UnitPage {
  private item: any;

  private id: string;
  private month: number;
  private year: number;
  private name: string;
  private desc: string;

  constructor(public navCtrl: NavController, public navParams: NavParams) {
//    console.dir(navParams.data);

    this.id = navParams.data.Id;
    this.month = navParams.data.Month;
    this.year = navParams.data.Year;
    this.name = navParams.data.Name;
    this.desc = navParams.data.Description;

    /*
    console.dir(this.id);
    console.dir(this.month);
    console.dir(this.year);
    console.dir(this.name);
    console.dir(this.desc);
*/

    this.item = this.getFakeData();
  }

  ionViewDidLoad() {
//    console.log('ionViewDidLoad UnitPage');
  }

  private getFakeData() {
    let data = [{ "Id": "71d521d7-0ba9-4fad-b243-90bd9cf29ca0", "Description": "Article Description 1", "Month": "January", "Name": "Article 1", "Year": 2001 }, { "Id": "71d521d7-0ba9-4fad-b243-90bd9cf29ca1", "Description": "Article Description 2", "Month": "February", "Name": "Article 2", "Year": 2002 }, { "Id": "71d521d7-0ba9-4fad-b243-90bd9cf29ca3", "Description": "Article Description 3", "Month": "March", "Name": "Article 3", "Year": 2003 }, { "Id": "71d521d7-0ba9-4fad-b243-90bd9cf29ca4", "Description": "Article Description 4", "Month": "April", "Name": "Article 4", "Year": 2004 }, { "Id": "71d521d7-0ba9-4fad-b243-90bd9cf29ca5", "Description": "Article Description 5", "Month": "May", "Name": "Article 5", "Year": 2005 }, { "Id": "71d521d7-0ba9-4fad-b243-90bd9cf29ca6", "Description": "Article Description 6", "Month": "June", "Name": "Article 6", "Year": 2006 }, { "Id": "71d521d7-0ba9-4fad-b243-90bd9cf29ca7", "Description": "Article Description 7", "Month": "July", "Name": "Article 7", "Year": 2007 }, { "Id": "71d521d7-0ba9-4fad-b243-90bd9cf29ca8", "Description": "Article Description 8", "Month": "August", "Name": "Article 8", "Year": 2008 }, { "Id": "71d521d7-0ba9-4fad-b243-90bd9cf29ca9", "Description": "Article Description 9", "Month": "September", "Name": "Article 9", "Year": 2009 }, { "Id": "71d521d7-0ba9-4fad-b243-90bd9cf29caa", "Description": "Article Description 10", "Month": "October", "Name": "Article 10", "Year": 2010 }, { "Id": "71d521d7-0ba9-4fad-b243-90bd9cf29cab", "Description": "Article Description 11", "Month": "November", "Name": "Article 11", "Year": 2011 }, { "Id": "71d521d7-0ba9-4fad-b243-90bd9cf29cac", "Description": "Article Description 12", "Month": "December", "Name": "Article 12", "Year": 2012 }];
    console.dir(data);
    return data;
  };

  public itemClicked(item) {
//    console.dir(item);
    this.navCtrl.push(ArticlePage, item);
  };

  public doAddUnit() {
    console.dir("doAddUnit()");
  };
}


// WEBPACK FOOTER //
// ./src/pages/unit/unit.ts